import React from 'react';

import { Contactwrapper } from './styles';

function Contact() {
    return (
        <Contactwrapper>
            <figure>
                <img src="https://media.discordapp.net/attachments/716053343994118154/747577899158339584/Ativo_1.png" alt="" />
            </figure>

            <form>
                <h1>Get in Touch!</h1>

                <div>
                    <label htmlFor="">Name*</label>
                    <input type="text" name="" id="" placeholder="Your name..."  required/>
                </div>
                <div>
                    <label htmlFor="">Email*</label>
                    <input type="email" name="" id="" placeholder="Email Address" required/>
                </div>
                <div>
                    <label htmlFor="">Message*</label>
                    <textarea name="" id="" cols="30" rows="10" placeholder="Write message..." required></textarea>
                </div>

                <button>Get your Estimate</button>
            </form>
        </Contactwrapper>
    );
}

export default Contact;